import classNames from 'classnames';
import { ButtonHTMLAttributes, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import styles from './remove.module.scss';

import { ReactComponent as IconClose } from '../../../../assets/images/close.svg';
import { collectionData, removeProductFromCollection } from '../../../../store/collection';

interface IRemoveButton {
    horizontalMode?: boolean;
    urn: string;
}

const RemoveButton: FC<IRemoveButton & ButtonHTMLAttributes<HTMLButtonElement>> = ({
    urn,
    className,
    horizontalMode = false,
    ...props
}) => {
    const dispatch = useDispatch();
    const collection = useSelector(collectionData);
    const isActive = collection.join('---').includes(urn);

    return isActive ? (
        <button
            onClick={() => dispatch(removeProductFromCollection(urn))}
            className={classNames(styles.remove, className, horizontalMode ? styles.horizontalMode : '')}
            {...props}
        >
            <IconClose width="14" height="14" />
        </button>
    ) : (
        <></>
    );
};

export default RemoveButton;
